<template>
  <b-row>
    <b-col sm="12">
      <b-card header="Listado de flota">
        <div class="table-responsive">
          <div class="form-group form-inline pull-left">
            <input v-model="search" type="search" class="form-control" placeholder="Buscar..."> &nbsp;
          </div>
          <div class="form-group form-inline pull-right">
            <button @click="newTruck" type="button" class="btn btn-primary">Nuevo</button>&nbsp;
            <download-excel
              class="btn btn-primary"
              :data="filteredTrucks"
              :fields="json_fields"
              name="Flota.xls"
            >Descargar Excel</download-excel>
          </div>
          <table class="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>Activo</th>
                <th>Placa</th>
                <th>Servicio</th>
                <th>Proveedor</th>
                <th>Modalidad</th>
                <th>IMEI</th>
                <!-- <th>Carreta</th> -->
                <th>Expiración SOAT</th>
                <th>Expiración Revisión técnica</th>
                <th>Año fabricación</th>
              </tr>
            </thead>
            <tbody>
              <tr
                @contextmenu.prevent="selectTruck(truck, k)"
                v-for="(truck, k) in filteredTrucks"
                :key="k"
              >
                <td>
                  <input @click="changeStatus(truck, k)" type="checkbox" :checked="truck.active">
                </td>
                <td>{{truck.plate}}</td>
                <td>{{truck.service ? truck.service.name : ''}}</td>
                <td>{{truck.provider ? truck.provider.name : ''}}</td>
                <td>{{truck.truck_mode.name}}</td>
                <td>{{truck.imei}}</td>
                <!-- <td>{{truck.cart ? truck.cart.plate : ''}}</td> -->
                <td>{{formatDate(truck.expiration_soat)}}</td>
                <td>{{formatDate(truck.expiration_rev_tech)}}</td>
                <td>{{truck.manufacturing_year || '--'}}</td>
              </tr>
            </tbody>
          </table>
          <context-menu id="context-menu" ref="ctxMenu">
            <li v-on:click="editTruck" class="ctx-item">Editar</li>
          </context-menu>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import contextMenu from "vue-context-menu";
import api from "@/helpers/api";
import moment from "moment";
import truck_fields from '@/helpers/json_fields/truck'

export default {
  components: { contextMenu },
  data() {
    return {
      trucks: [],
      search: "",
      provider: {},
      json_fields: truck_fields
    };
  },
  methods: {
    changeStatus(truck, i) {
      api
        .put(`/truck/${truck.id}`, { active: !truck.active })
        .then(response => {
          if (response.success) {
            this.filteredTrucks = response.truck;
          }
        });
    },
    editTruck() {
      let route = this.$router.resolve({path: `/fleet/edit/${this.truck.id}`});
      window.open(route.href, '_blank');
      // this.$router.push({
      //   path: `/fleet/edit/${this.truck.id}`,
      //   params: { id: this.truck.id }
      // });
    },
    newTruck() {
      this.$router.push({
        path: `/fleet/new`
      });
    },
    selectTruck(truck, key) {
      this.truck = truck;
      this.key = key;
      this.$refs.ctxMenu.open();
    },
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    },
    getMode(mode){
      switch(mode){
        case 'OWNER': return 'Propio'; break;
        case 'RENTED': return 'Alquilado'; break;
        case 'THIRD': return 'Tercero'; break;
      }
    }
  },
  mounted() {
    api.get("/trucks").then(response => {
      this.trucks = response.trucks;
    });
  },
  computed: {
    filteredTrucks: {
      get: function() {
        return this.trucks.filter(truck => {
          let text = this.search.toLowerCase();
          let condition = true

          if(text){
            condition = condition && (truck.plate.toLowerCase().includes(text) ||
                        truck.service.name.toLowerCase().includes(text) ||
                        truck.provider.name.toLowerCase().includes(text) ||
                        truck.imei.toLowerCase().includes(text)) ;
          }

          return condition; 
        });
      },
      set: function(truck) {
        const index = this.trucks.findIndex(tr => tr.id === truck.id);
        if (index >= 0) {
          this.trucks.splice(index, 1, truck);
        }
      }
    }
  }
};
</script>
